import TopNav from "../../components/TopNav/TopNav";
import ImagingHeader from "./ImagingHeader";
import ImagingNewHeader from "./ImagingNewHeader";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
// import "./AllNewPackages.css";
// import OurNewPackages from "../../Pages/packageDetailsPage/OurNewPackages";
// import Footer from "../../components/Footer/Footer";
import ImagingFooter from "./ImagingFooter";
import SubFooter from "../../components/SubFooter/SubFooter";
import ScrolltoTop from "../../components/Scrolltotop/ScrolltoTop";
import AddressPopUp from "./AddressPopUp";
import {
  getAllPackageList,
  getAllImagingPackageList,
  getPackageList,
  setCity,
} from "../../Redux/Actions";
import { useState } from "react";
import { Scroll } from "../../components/Scroll function/scroll";
import SimpleForm from "../../components/chatbot/SimpleForm";
import PackageName from "../../Pages/packageDetailsPage/PackageName";
import { useHistory, useParams, useLocation } from "react-router-dom";
import Pagination from "../../components/Pagination/Pagination";
// import "../../components/Pagination/Pagination.css";
import { AiFillRightCircle } from "react-icons/ai";
import { AiFillLeftCircle } from "react-icons/ai";
import { loader } from "mini-css-extract-plugin";
import Loader from "../../components/Loader/Loader";
import OurImagingPackages from "./OurImagingPackages";
import { Ourpackages } from "./Imaging";

// import OurNewImagingPackages from "./OurNewImagingPackages";

function ImagingPackage({ location }) {
  const { type } = useLocation();
  console.log(type, "??????");
  const packagelist1 = useSelector((state) => state.packageList);

  const Package_Categories = useSelector((state) => state.packageCategory);
  const Package_Filtered = useSelector((state) => state.packageFilter);

  //getting imagine pacakges
  useEffect(() => {
    dispatch(getAllImagingPackageList());
  }, []);

  const imaginePackages = useSelector((state) => state.getImgPackagesReducer);

  console.log("iamgine pacakges", imaginePackages);
  const { loading: ImgLoading, ImgPackagesPageNation } = imaginePackages;
  //  console.log(packagelist1?.packages,"tyuti");
  const { loading, packages } = packagelist1;

  // useEffect(() =>{
  //   if(ImgLoading){
  //     console.log("loading")
  //   }else{
  //     setlength(imaginePackages.);
  //   }
  // },[])
  const [page, setPage] = useState(1);

  const [Package_Category, setPackage_Category] = useState("");

  // const [AllPackages_active, setAllPackages_active] = useState(false);

  const dispatch = useDispatch();
  const { state } = location;
  const [activePackage, setactivePackage] = useState("");
  const [searchFromButton, setsearchFromButton] = useState(state);
  const citySelected = useSelector((state) => state.cityOnTopNav);
  const [pagination, setpagination] = useState(true);
  const AllpackageListing = useSelector((state) => state.allpackage);
  const { AllpackDetail, loading: clickLoader } = AllpackageListing;
  const filPack = AllpackageListing?.AllpackDetail?.results;
  // console.log("filter pacakges ",filPack.length)
  const [allPack, setallPack] = useState(true);
  console.log(AllpackageListing);

  useEffect(() => {
    setsearchFromButton(state);
    if (state?.length > 0) {
      // setAllPackages_active(true)
      setpagination(false);
      setactivePackage("");
    } else if (state?.length === 0) {
      console.log("search becomes zero length");
    }
  }, [state]);

  // const FilterOnclick = (packageName) => {
  //   dispatch(getAllPackageList(packageName, citySelect));
  //   setallPack(false);
  //   setpagination(false);
  // };

  const packageCategories = [
    {
      id: 1,
      name: "MRI",
    },
    {
      id: 2,
      name: "PET",
    },
    {
      id: 3,
      name: "USG",
    },
    {
      id: 4,
      name: "CT",
    },
    {
      id: 5,
      name: "MAM",
    },
    {
      id: 6,
      name: "DEXA",
    },
    {
      id: 7,
      name: "CAR",
    },
    {
      id: 8,
      name: "NEU",
    },
    {
      id: 9,
      name: "NUC",
    },
  ];

  const handleActivePage = () => {
    //setFiltered(packages?.results);
    dispatch(getAllImagingPackageList("", citySelect, page));
    setsearchFromButton("");
    setactivePackage("");
    setpagination(true);
    setallPack(true);
  };

  const { loading: loadingCity, citySelect } = citySelected;

  const currentCity = useRef();

  const { citySlug } = useParams();
  const history = useHistory();

  useEffect(() => {
    dispatch(getAllImagingPackageList("", citySelect, page, type));
    setactivePackage(type);
  }, [page]);

  useEffect(() => {
    currentCity.current = citySelect;
    try {
      let NewArray = citySlug.replace(" ", "_").split("_");
      let firstName =
        NewArray[0].substring(0, 1).toUpperCase() + NewArray[0].substring(1);
      var JoinedCityName = firstName;
      if (NewArray.length > 1) {
        let secondName =
          NewArray[1].substring(0, 1).toUpperCase() + NewArray[1].substring(1);
        JoinedCityName = firstName + "_" + secondName;
      }
    } catch (error) {
      console.log(error);
    }
    Scroll();
    dispatch(setCity(JoinedCityName));
  }, []);
  // useEffect(() => {
  //   if(!packages?.results)
  //   dispatch(getPackageList(counter));
  // }, []);

  // const filterFunc = (id) => {
  //   const Filter_Packages = packages?.results.filter((value) => {
  //     return value.id == id;
  //   });
  //    setFiltered(Filter_Packages);
  // };

  // useEffect(() => {
  //   if(packages?.results && Filtered ){
  //     setFiltered([...Filtered,...packages.results])
  //   }
  // }, [counter])

  const FilterOnclick = (value) => {
  
    dispatch(getAllImagingPackageList("", citySelect, 1, value || type));
    console.log( "page", page)
  };

  useEffect(() => {
    if (currentCity.current !== citySelect) {
      dispatch(getAllImagingPackageList("", citySelect, 1));
      history.push(
        `/imaging/health-checkup-packages${
          citySelected.citySelect
            ? `-${citySelected.citySelect.toLowerCase().replace(" ", "_")}`
            : ""
        }`
      );
    }
  }, [citySelected.citySelect]);

  const onPageChanged = (data) => {
    
    const { currentPage } = data;
    // console.log(data, "amgine pacakges");
    if (type) {
      dispatch(getAllImagingPackageList("", citySelect, currentPage, type));
    } else {
      dispatch(getAllImagingPackageList("", citySelect, currentPage));
    }
  };

  function scrollWin() {
    var div = document.getElementById("allPackage");
    div.scrollBy(100, 0);
  }
  function scrollLeftWin() {
    var div = document.getElementById("allPackage");
    div.scrollBy(-100, 0);
  }

  const getAllPackage = (e) => {
    e.preventDefault();
    if (currentCity.current !== citySelect) {
      history.push({
        pathname: `/imaging/health-checkup-packages${
          citySelected.citySelect
            ? `-${citySelected.citySelect.toLowerCase().replace(" ", "_")}`
            : ""
        }`,
        state: [AllpackDetail.results],
      });
    }
  };

  return (
    <>
      <ImagingNewHeader />
      <div className="backgroundColor">
        <div className="AllNewPackages">
          <div className="allpackagesheading">
            <h1>Our Top Tests</h1>
          </div>
          <div className="scrollBtn">
            <div className="scrollLeftDiv" onClick={scrollLeftWin}>
              <AiFillLeftCircle className="rightIcon" />
            </div>
            <div className="scrollRightDiv" onClick={scrollWin}>
              <AiFillRightCircle className="rightIcon" />
            </div>
          </div>
          <div className="AllpackagesDiv AllpackagesDiv2" id="allPackage">
            <div className="AllpackagesName pkg">
              <div
                className={
                  activePackage == ""
                    ? "AllpackagesBlock fontColoR"
                    : "AllpackagesBlock"
                }
                onClick={handleActivePage}
              >
                All Tests
              </div>
              {packageCategories?.map((value, index) => (
                <div
                  className="packagesName"
                  onClick={() => {
                    setPackage_Category(value.name);
                    setsearchFromButton("");
                    setactivePackage(value.name);
                    setPage(1);
                    FilterOnclick(value.name);
                  }}
                  key={value.id}
                >
                  <PackageName
                    value={value.name}
                    activePackage={activePackage}
                    state={state}
                  />
                </div>
              ))}
            </div>
          </div>
          <div className="PackageList">
            {/* {console.log(Filtered)} */}
            {/* {Filtered && Filtered !==""  ? ( <OurNewImagingPackages values={Filtered} />) : ( <OurNewImagingPackages values={packages} />) } */}

            {searchFromButton?.length > 0 ? (
              <OurImagingPackages values={searchFromButton[0]} />
            ) : allPack ? (
              ImgLoading ? (
                "loading"
              ) : (
                <OurImagingPackages values={imaginePackages?.ImgPackages} />
              )
            ) : clickLoader ? (
              <Loader />
            ) : (
              <OurImagingPackages values={filPack} />
            )}
          </div>
          {ImgLoading ? (
            "Loading"
          ) : (
            <div className="See_more_Div">
              <Pagination
                onPageChanged={onPageChanged}
                pageNeighbours={1}
                pageLimit={Number(6)}
                totalRecords={parseInt(ImgPackagesPageNation?.count)}
                currentPage={page}
                setCurrentPage={setPage}
              />
            </div>
          )}
        </div>
      </div>
      <ImagingFooter telNumber="898 898 0101" />
      <div className="chatbot">
        <SimpleForm />
      </div>
      {/* <SubFooter /> */}
      <ScrolltoTop />
    </>
  );
}
export default {
  component: ImagingPackage,
};
